var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tags-box"},[(_vm.showTagsAll)?_c('tagsAll'):_c('tagInfo',{key:_vm.tagId})],1)}
var staticRenderFns = []

export { render, staticRenderFns }